export const COMPETITIONS_RECEIVED = 'COMPETITIONS_RECEIVED';
export const LOADING_COMPETITIONS = 'LOADING_COMPETITIONS';
export const LEAGUES_RECEIVED = 'LEAGUES_RECEIVED';
export const LEAGUE_RECEIVED = 'LEAGUE_RECEIVED';
export const LOADING_LEAGUE = 'LOADING_LEAGUE';
